/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';

import user from './user';

Vue.use(Vuex);

const store = new Vuex.Store({
  namespaced: true,
  modules: {
    user,
  },
  state: {
    isLoading: false,
    windowSize: {
      width: window.innerWidth,
      height: window.innerHeight,
    },
    serviceDetails : {
      service_name : '',
      look_id : '',
      menu_name: '',
    },
  },
  getters: {
    isLoading(state) {
      return state.isLoading;
    },
    breakpoint(state) {
      if (state.windowSize.width < 576) return 'xs';
      if (state.windowSize.width < 800) return 'sm';
      if (state.windowSize.width < 1100) return 'md';
      if (state.windowSize.width < 1600) return 'lg';
      return 'xl';
    },
    getServiceDetails: state => {
      return state.serviceDetails;
    },
  },
  mutations: {
    setLoading(state, loading) {
      state.isLoading = loading;
    },
    refreshWindowSize(state) {
      state.windowSize.width = window.innerWidth;
      state.windowSize.height = window.innerHeight;
    },
    setServiceDetails (state, service) {
      state.serviceDetails = service
    },
  },
  actions: {
    setLoading({ commit }, loading) {
      commit('setLoading', loading);
    },
    refreshWindowSize({ commit }) {
      commit('refreshWindowSize');
    },
  },
});

window.$store = store;

export default store;
